import { ISchoolSearch } from "./SchoolSearchCard.def";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { SchoolBadges } from "../../SchoolBadges";
import { TbStarFilled, TbStarHalfFilled } from "react-icons/tb";
import { ISchoolSearchItem } from "types/artifacts/search-schools";
import { StaticMap } from "components/maps/StaticMap";

export function SchoolSearchCard(props: ISchoolSearchItem) {
  const score = props?.rating?.score || "";
  const text = props?.rating?.text || "";
  const rating = props?.rating?.index ?? 0; // e.g. 4.3, 4.5, …
  const fullStars = Math.floor(rating); // 4
  const hasHalfStar = rating - fullStars >= 0.5; // true  → one half
  const blankStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  const [longitude, latitude] = props.location || [];
  const url = props?.url || '';
  const schoolDetailsUrl = url?.endsWith('?appview=1') ? url.slice(0, -10) : url;

  return (
    <div style={props?.maxWidth ? { maxWidth: props?.maxWidth } : {}}>
      <a
        href={schoolDetailsUrl}
        className="card card--portrait_medium mb-2 school_card"
        style={{ minHeight: "350px", width: "100%" }}
        target="_blank"
      >
        <div className="card--portrait_medium__image_content card--portrait_medium__image_content">
          <div className="card--portrait_medium__image_content__image">
            {longitude && latitude ? (
              <StaticMap
                latitude={latitude}
                longitude={longitude}
                zoom={12}
                width={310}
                height={180}
              />
            ) : (
              <img
                className="staticmap-img"
                src="https://content.harstatic.com/img/common/nophoto.jpg"
                alt="Static map"
              />
            )}
          </div>
        </div>
        <div className="card--portrait_medium__content text-left">
          <div className="pb-2">
            <h4
              className="color_carbon mb-0 truncate-2-lines school_card_title"
              title={props.school_name}
            >
              {props.school_name}
            </h4>
            {props?.grade_span && (
              <div className="font_size--small color_auxiliary pb-2">
                Grade Span: {props?.grade_span}
              </div>
            )}
            <div className="pb-3">
              {[...Array(fullStars)].map((_, i) => (
                <TbStarFilled key={i} color="#3EB0FF" />
              ))}
              {hasHalfStar && <TbStarHalfFilled />}
              {[...Array(blankStars)].map((_, i) => (
                <TbStarFilled key={i} color="#D8D8D8" />
              ))}
              {/* <StarRating max={5} value={props.rating?.index} readOnly={false} size="1.4rem" /> */}
            </div>
            {score && text && (
              <div className="d-flex align-items-center">
                {score && (
                  <div
                    className={`label label--grade label--grade_${score?.toLowerCase()}`}
                  >
                    {score}{" "}
                  </div>
                )}
                {text && (
                  <span className="font_size--medium color_auxiliary">
                    {text}
                  </span>
                )}
              </div>
            )}
            <div className="pt-3">
              <SchoolBadges badges={props.rating?.badges || []} />
            </div>
          </div>
        </div>
      </a>
    </div>
  );
}

export namespace SchoolSearchCard {
  export function Carousel(props: ISchoolSearch) {
    const { schools = [], schoolsCount = 0 } = props

    return (
      <Swiper
        className="swiper-properties swiper-schools mt-2"
        spaceBetween={10}
        modules={[Navigation]}
        slidesPerView={"auto"}     // ✅ important (fixed width slides)
        slidesPerGroup={1}         // ✅ next button moves 1 card
        navigation={true}
        grabCursor={true}
        simulateTouch={true}
        threshold={5}
        watchOverflow={true}
        breakpoints={{
          0: {
            slidesPerView: "auto",
            slidesPerGroup: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: "auto",
            slidesPerGroup: 1,
            spaceBetween: 12,
          },
          1067: {
            slidesPerView: 3,      // ✅ desktop shows 3 full cards
            slidesPerGroup: 1,     // keep 1 if you want step-by-step
            spaceBetween: 10,
          },
        }}
      >
        {schools.map((schoolDetails, index) => (
          <SwiperSlide
            key={`${schoolDetails.school_id}-${index}`}
            className={schoolsCount < 3 ? `swiper-slider-item` : ""}
          >
            <SchoolSearchCard {...schoolDetails} />
          </SwiperSlide>
        ))}
      </Swiper>
    );
  }
}
